module.exports = __webpack_public_path__ + "img/uba.a28244e5.png";